var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabletOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10210_22815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.832 0.5H3.4987C3.05667 0.5 2.63275 0.675595 2.32019 0.988155C2.00763 1.30072 1.83203 1.72464 1.83203 2.16667V14.8333C1.83203 15.0522 1.87514 15.2689 1.9589 15.4711C2.04266 15.6733 2.16542 15.8571 2.32019 16.0118C2.47495 16.1666 2.65868 16.2894 2.86089 16.3731C3.0631 16.4569 3.27983 16.5 3.4987 16.5H12.832C13.0509 16.5 13.2676 16.4569 13.4698 16.3731C13.672 16.2894 13.8558 16.1666 14.0105 16.0118C14.1653 15.8571 14.2881 15.6733 14.3718 15.4711C14.4556 15.2689 14.4987 15.0522 14.4987 14.8333V2.16667C14.4987 1.72464 14.3231 1.30072 14.0105 0.988155C13.698 0.675595 13.2741 0.5 12.832 0.5ZM8.16536 15.8333C7.61203 15.8333 7.16536 15.3867 7.16536 14.8333C7.16536 14.28 7.61203 13.8333 8.16536 13.8333C8.7187 13.8333 9.16536 14.28 9.16536 14.8333C9.16536 15.3867 8.7187 15.8333 8.16536 15.8333ZM13.1654 13.1667H3.16536V2.5H13.1654V13.1667Z",
    fill: "url(#paint0_linear_10210_22815)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10210_22815",
    x1: 1.83203,
    y1: 0.5,
    x2: 17.5221,
    y2: 4.43017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F4FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10210_22815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletOutline);
export default __webpack_public_path__ + "static/media/tablet-outline.dd1db909d83536207db0431e48704911.svg";
export { ForwardRef as ReactComponent };